import Loadable from 'react/components/loadable';

const SequenceSettingsDrawer = Loadable({
  loader: () => import('../../pages/sequences/sequences_list/sequences_settings_drawer'),
  type: 'drawer',
});

angular.module('gym').value('SequenceSettingsDrawer', SequenceSettingsDrawer);
